import { map } from 'lodash';
import { z } from 'zod';

import { type BodyOf, FeApi } from '..';
import { SiteMetadata } from '../domain/entities/site-metadata';
import type { ISiteMetadataRepository } from '../domain/repositories/site-metadata.repository';

import { siteMetadataSectionMapper } from './entities/site-metadata.mapper';

export namespace SiteMetadataRepositoryMapper {
  export namespace getAll {
    export const outputSchema = z.array(SiteMetadata.Section.Schema);

    export function outputFromData(
      data: {
        /** The section name (e.g., 'system', 'array') */
        section?: string;
        content?: {
          /** Name of the attribute */
          attribute_name?: string;
          /** Value of the attribute */
          value?: string;
        }[];
      }[],
    ): Promise<SiteMetadata.Section[]> {
      return outputSchema.parseAsync(map(data, siteMetadataSectionMapper));
    }

    export function bodyFromInput(
      input: ISiteMetadataRepository.GetAllInput,
    ): BodyOf<typeof FeApi.customerInfosV1SitesMetadataRetrieve> {
      return {
        accureId: input.siteId,
      };
    }
  }
}
